import { makeStyles } from "tss-react/mui";


export const threePsStyles = makeStyles()({
  maskButton: {
    borderRadius: "20px",
    position: "relative",
    background: "#EFEFF0",
    // boxShadow: "1px 1px 2px rgb(165, 165, 165) inset",
    "& .MuiButton-root": {
      right: "0",
      minWidth: "unset",
      borderRadius: "20px",
      width: "58px",
      height: "27px",
      fontWeight: "400",
      transition: "all 0.2s 0.1s ease",
      "&:hover": {
        opacity: "0.8",
      },
    },
  },
  mask: {
    width: "58px",
    height: "27px",
    borderRadius: "20px",
    background: "#108F2C",
    position: "absolute",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
    transition: "all 0.5s ease",
  },
  tagStyle: {
    fontSize: "15px",
    fontWeight: "500",
    color: "#000000",
  },
  firstTab: {
    maxWidth: "48px",
    minWidth: "58px",
    padding: "0",
    paddingLeft: "20px",
    marginRight: "20px",
  },
  textStyle: {
    fontSize: "15px",
    color: "#646464",
    fontWeight: "600",
    marginBottom: "15px",
  },
  heading: {
    fontSize: "15px",
    color: "#000",
    fontWeight: "600",
    paddingLeft: "5px",
  },
  mainblock: {
    background: "#fff",
    padding: "20px",
    height: "calc(100vh - 100px)",
    flexWrap: "nowrap",
    overflow: "auto",
  },
  SaveChangesButtonStyle:{
    background:"#43784A",
    color:"#fff !important",
    borderRadius:"5px",
    padding:"10px 50px",
    "&:hover":{
    background:"#43784A",
    }
  },
  threePsCard:{
    padding:"20px 20px  15px 20px",
    borderRadius:"15px",
    boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.25) !important",
    maxWidth:"167px",
    margin:"0px 20px 10px 0px",
    flexWrap:"nowrap"
  }
});